/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Error_TitleInputs */

const es_toast_error_title = /** @type {(inputs: Toast_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

const en_toast_error_title = /** @type {(inputs: Toast_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

/**
* | output |
* | --- |
* | "Error" |
*
* @param {Toast_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const toast_error_title = /** @type {((inputs?: Toast_Error_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Error_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_error_title(inputs)
	return en_toast_error_title(inputs)
});
export { toast_error_title as "toast.error_title" }